<template>
  <Transition mode="in-out">
    <div class="video-mini" v-show="isEnableVideoCallFeature && showModalMinimizeCall && call_session?.call_type === 'video_call'">
      <video id="miniVideo" ref="miniVideo" autoplay playsinline muted></video>
    </div>
  </Transition>
</template>

<script>
// import moment from 'moment';
// import JsSIP from 'jssip';
import { toSvg } from 'jdenticon';
// import popupErrorMessages from '@/library/popup-error-messages';

export default {
  name: 'PreviewMinimizeVideoCall',
  props: {
    show: {
      type: Boolean,
      default: true,
    },
    call_session: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      showModalMinimizeCall: false,
      showVideo: false,
      isMutedCall: false,
    };
  },
  computed: {
    activeWorkspace() {
      return this.$store.state.workspace.activeWorkspace || {};
    },
    isEnableVideoCallFeature() {
      return this.activeWorkspace.products && this.activeWorkspace.products[0].pricing.whatsapp.enable_video_call_feature;
    },
  },
  methods: {
    identicons(value) {
      return toSvg(value, '75');
    },
    onHide() {
      this.$emit('onHide');
    },
  },
  watch: {
    show() {
      this.showModalMinimizeCall = this.show;
    },
  },
};
</script>

<style>
.flex-container {
  display: flex;
  justify-content: space-between;
  margin-inline-end: auto;
}

.video-mini {
  flex-grow: 1;
  width: 15%;
  height: auto;
  max-height: 250%;
  border-radius: 5px;
  position: absolute;
  top: 560px;
  left: 25px;
  z-index: 1000;
}
.video-mini video {
  width: 100%;
  border-radius: 5px;
  object-fit: cover;
  height: 200px;
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}

.mirrored {
  transform: scaleX(-1);
  -webkit-transform: scaleX(-1);
}

.el-loading-mask {
  z-index: 200;
}
</style>
